export default "__VITE_ASSET__d822b71c__"